import { useEffect } from "react";
import { FilterTab } from "../../../components/Filters";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/state/SwitchTabs";
import { DataTabs } from "./Data";
import { setViewMode } from "../../../store/state/ViewMode";

const SecondaryHeader = ({ showViewMode = true }) => {
  const dispatch = useDispatch();
  const activeViewMode = useSelector((state: any) => state.viewMode.activeView);
  const tabNames = useSelector((state: any) => state.switchTabs.tabNames);
  const selectedTab = useSelector((state: any) => state.switchTabs.activeTab);

  const handleTabChange = (option: string) => {
    dispatch(setActiveTab(option));
    const url = new URL(window.location.href);
    url.searchParams.set("tab", option);
    window.history.pushState({}, "", url);
  };

  useEffect(() => {
    // Update selected tab if URL changes
    const handlePopState = () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tab && tabNames.includes(tab)) {
        dispatch(setActiveTab(tab));
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [dispatch, tabNames]);

  useEffect(() => {
    dispatch(setViewMode(DataTabs[0]));
  }, [dispatch]);

  return (
    <div className="bg-white p-[0.5rem] rounded-xl flex flex-wrap gap-3 justify-between items-center">
      <>
        <div>
          {showViewMode && (
            <div>
              <FilterTab
                options={DataTabs.map((item) => item.label)}
                selected={[activeViewMode.label]}
                onClick={(option, index) => {
                  dispatch(setViewMode(DataTabs[index]));
                }}
              />
            </div>
          )}
        </div>

        {tabNames.length === 1 ? (
          <div className="tab tab-active rounded-lg	">{tabNames[0]}</div>
        ) : (
          <FilterTab
            options={tabNames}
            selected={[selectedTab]}
            onClick={handleTabChange}
          />
        )}
      </>
    </div>
  );
};

export default SecondaryHeader;
